import React from 'react';
import ProductListFunctional from './components/product-list-functional';

const ProductList = () => {
	return <ProductListFunctional />;
};

export default ProductList;
